import { render, staticRenderFns } from "./ImageLightbox.vue?vue&type=template&id=59535f21&scoped=true"
import script from "./ImageLightbox.vue?vue&type=script&lang=js"
export * from "./ImageLightbox.vue?vue&type=script&lang=js"
import style0 from "./ImageLightbox.vue?vue&type=style&index=0&id=59535f21&prod&lang=css"
import style1 from "./ImageLightbox.vue?vue&type=style&index=1&id=59535f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59535f21",
  null
  
)

export default component.exports